// removed by extract-text-webpack-plugin
module.exports = {"realtorsBlock":"_1E61p7EPclA7p17_Gtcnz6","realtor":"_1m2R9IVh2ja5RZvq69LoTL","realtorImage":"_2kk-RxOek5HWO4YlfCL1a6","staff":"_2Zuhl2d0FAfuAPCmXGa2DX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyRealtors/CompanyRealtors.scss
// module id = 1584
// module chunks = 0